import { render, staticRenderFns } from "./company-selector.vue?vue&type=template&id=538a2a72"
import script from "./company-selector.vue?vue&type=script&lang=js"
export * from "./company-selector.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports